import React from "react";

export default function Google() {
  return (
    <>
      <svg
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.1 10.4947C20.1 9.78558 20.0364 9.10376 19.9182 8.44922H10.5V12.3174H15.8818C15.65 13.5674 14.9455 14.6265 13.8864 15.3356V17.8447H17.1182C19.0091 16.1038 20.1 13.5401 20.1 10.4947Z"
          fill="#4285F4"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.4999 20.268C13.1999 20.268 15.4636 19.3725 17.1181 17.8452L13.8863 15.3361C12.9908 15.9361 11.8454 16.2907 10.4999 16.2907C7.89539 16.2907 5.69084 14.5316 4.90448 12.168H1.56357V14.7589C3.20902 18.0271 6.59084 20.268 10.4999 20.268Z"
          fill="#34A853"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.90455 12.1722C4.70455 11.5722 4.59091 10.9313 4.59091 10.2722C4.59091 9.61307 4.70455 8.97216 4.90455 8.37216V5.78125H1.56364C0.886364 7.13125 0.5 8.65852 0.5 10.2722C0.5 11.8858 0.886364 13.4131 1.56364 14.7631L4.90455 12.1722Z"
          fill="#FBBC05"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.4999 4.2429C11.9681 4.2429 13.2863 4.74744 14.3227 5.73835L17.1908 2.87017C15.459 1.25653 13.1954 0.265625 10.4999 0.265625C6.59084 0.265625 3.20902 2.50653 1.56357 5.77472L4.90448 8.36562C5.69084 6.00199 7.89539 4.2429 10.4999 4.2429Z"
          fill="#EA4335"
        />
      </svg>
    </>
  );
}
